import * as React from "react";
import {useEffect, useState} from "react";
import {InputFieldState} from "./InputFieldState";
import newId from "../helpers/NewId";

interface CheckBoxProps {
  label: string;
  state?: InputFieldState;
  onChange?: (value: string, isChecked: boolean, event: React.ChangeEvent<HTMLInputElement>) => void;
  insertDangerously?: boolean;
}

export function CheckBox({
                           label = "Label",
                           state,
                           onChange,
                           insertDangerously
                         }: CheckBoxProps) {
  const [isChecked, setIsChecked] = useState(state.isChecked);
  const id = newId(); // Use React's useId hook for unique IDs

  useEffect(() => {
    if (state.isChecked !== isChecked) {
      setIsChecked(state.isChecked);
    }
  }, [state.isChecked]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newState = !isChecked;
    setIsChecked(newState);
    onChange(event.target.value, newState, event);
  };

  return (
    <div>
      <label htmlFor={id}>
        <input
          id={id}
          checked={isChecked}
          readOnly={state.editable === false}
          onChange={handleChange}
          value={state.value}
          type="checkbox"
        />
        {insertDangerously ? (
          <span dangerouslySetInnerHTML={{__html: label}} style={{ marginBottom: '15px' }}/>
        ) : (
          <span style={{ color: 'black', marginBottom: '15px', marginTop: '15px' }}>{label}</span>
        )}
      </label>
      {state.errorMessage &&
          <div className="error_message">{state.errorMessage}</div>
      }
    </div>
  );
}
